import "jquery";
import "selectedIcons";
import "components/top-menu";
import "components/header";
import "components/footer";
import "components/dynamic-grid";
import JSZip from "jszip/dist/jszip";
import "@progress/kendo-ui/js/kendo.combobox";
import "@progress/kendo-ui/js/kendo.grid";
import "@progress/kendo-ui/js/kendo.aspnetmvc";

window.JSZip = JSZip;